import { useMutation } from "@tanstack/react-query";

import getTbiApi from "@/api/api-v1";
import { useInvalidateProjectQueries } from "@/queries/query-projects";
import { useOnError } from "@/utils/on-error";

export function useDeleteReport() {
  const invalidateProjectQueries = useInvalidateProjectQueries();
  const onError = useOnError("Rapportage verwijderen mislukt.");

  return useMutation({
    mutationFn: async (slug: string) => {
      await getTbiApi().ProjectsApi.projectsDestroy({
        slug,
      });
      invalidateProjectQueries(slug);
    },
    onError,
  });
}
